export default __webpack_public_path__ + "static/media/help-active.0f200241.svg";